import {
  HttpClient, HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { apiConfiguration } from '../../../../configurations/api-configuration';
import { AccessService } from '../../../application/services/AccessService';
import { HttpResponse } from '../../../application/types/HttpResponse';
import {
  KanbanTask,
  SaveKanbanTaskData,
} from '../../types/Workspace';

@Injectable()
export class KanbanApiService {
  private readonly kanbanTasksUrl = `${apiConfiguration.baseApiUrl}/kanban-tasks`;

  public constructor(
    private http: HttpClient,
    private accessService: AccessService,
  ) { }

  public async getKanbanTasks(): Promise<HttpResponse<KanbanTask[]>> {
    return lastValueFrom(this.http.get<HttpResponse<KanbanTask[]>>(this.kanbanTasksUrl, { headers: this.getHeaders() }));
  }

  public async createKanbanTask(data: SaveKanbanTaskData): Promise<HttpResponse<KanbanTask>> {
    return lastValueFrom(this.http.post<HttpResponse<KanbanTask>>(this.kanbanTasksUrl, data, { headers: this.getHeaders() }));
  }

  public async updateKanbanTask(taskId: string, data: Partial<SaveKanbanTaskData>): Promise<HttpResponse<KanbanTask>> {
    return lastValueFrom(this.http.put<HttpResponse<KanbanTask>>(`${this.kanbanTasksUrl}/${taskId}`, data, { headers: this.getHeaders() }));
  }

  public async deleteKanbanTask(taskId: string): Promise<HttpResponse<void>> {
    return lastValueFrom(this.http.delete<HttpResponse<void>>(`${this.kanbanTasksUrl}/${taskId}`, { headers: this.getHeaders() }));
  }

  private getHeaders(): HttpHeaders {
    const token = this.accessService.getToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
